import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularPremiumPerson: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_premium-person"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="premium-person icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M17.9989 3C18.2398 3 18.4638 3.11546 18.6038 3.30649L18.6585 3.39288L21.922 9.42119L21.9599 9.51408L21.972 9.5539L21.9921 9.65608L21.9979 9.75C21.9979 9.81904 21.9886 9.88589 21.9711 9.94938L21.9237 10.0754L21.8862 10.144C21.881 10.1523 21.8758 10.1605 21.8703 10.1686C21.8628 10.1797 21.8547 10.191 21.8465 10.2018L21.8458 10.2028C21.8347 10.2174 21.823 10.2318 21.8107 10.2457L21.83 10.2208L20.5563 11.6674C20.133 11.3596 19.6381 11.1444 19.1012 11.0514L19.587 10.5H16.6123L12.6986 20.5228C12.583 20.819 12.2999 21.0001 12 21.0002L11.9972 21.0002C11.9664 21.0001 11.9353 20.9981 11.9043 20.994L11.899 20.9937L11.8944 20.9927C11.8599 20.9878 11.8254 20.9804 11.7911 20.9704L11.7811 20.9682C11.7209 20.9509 11.6623 20.9254 11.6075 20.8922L11.5983 20.8847C11.5512 20.8564 11.5072 20.8218 11.4672 20.7815L2.17809 10.2352L2.15185 10.2025L2.11178 10.144C2.0563 10.0544 2.01921 9.9523 2.00569 9.84286L2 9.75L2.00285 9.68414L2.01606 9.59539C2.02225 9.56547 2.03015 9.53671 2.03966 9.5087L2.06248 9.45021L2.09048 9.39288L5.33943 3.39288C5.45413 3.18107 5.66229 3.03913 5.89695 3.00695L5.99895 3H17.9989ZM15.002 10.5H8.998L11.9989 18.187L12 18.1843V18.188L15.002 10.5ZM7.389 10.5H4.409L9.76 16.574L7.389 10.5ZM8.971 4.5H6.44495L4.007 9H7.531L8.971 4.5ZM13.4509 4.5H10.5459L9.105 9H14.89L13.4509 4.5ZM17.5519 4.5H15.026L16.466 9H19.988L17.5519 4.5ZM21 14.5C21 15.8807 19.8807 17 18.5 17C17.1193 17 16 15.8807 16 14.5C16 13.1193 17.1193 12 18.5 12C19.8807 12 21 13.1193 21 14.5ZM23 19.875C23 21.4315 21.7143 23 18.5 23C15.2857 23 14 21.4374 14 19.875V19.772C14 18.7929 14.7937 18 15.7727 18H21.2273C22.2063 18 23 18.793 23 19.772V19.875Z" />
      </svg>
    </span>
  );
};

export { RegularPremiumPerson };
